import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-su_014",
  "use": "icon-su_014-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-su_014\"><defs><style>#icon-su_014 .cls-1{fill:#777;}#icon-su_014 .cls-2{fill:none;opacity:0;}</style></defs><g id=\"icon-su_014_レイヤー_2\" data-name=\"レイヤー 2\"><g id=\"icon-su_014_icon\"><path class=\"cls-1\" d=\"M0,2V22H24V2ZM22,20H2V4H22Zm-4.5-9A2.5,2.5,0,1,0,15,8.5,2.5,2.5,0,0,0,17.5,11ZM20,16l-3-3-3,3L8,10,4,14v4H20Z\" /><rect class=\"cls-2\" width=\"24\" height=\"24\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol